import clsx from 'clsx';
import styles from '../styles/Button.module.css';

export default function Button({
  variant = 'primary',
  type = 'button',
  className,
  children,
  ...rest
}) {
  return (
    <button
      type={type}
      className={clsx(
        styles.base,
        variant === 'header' && styles.header,
        variant === 'primary' && styles.primary,
        variant === 'outline' && styles.outline,
        className
      )}
      {...rest}
    >
      {children}
    </button>
  );
}